import AnimeList from "../components/animeList/AnimeList";

const SearchedAnimes = () => {
  return <AnimeList />;
};

export default SearchedAnimes;
